module.exports = __webpack_public_path__ + "img/thumbnail_LittlePenguin_j_leucistic.e3c3fff0.png";